// services/api/axiosInterceptor.js
import axios from 'axios';

let sessionExpiredHandler = null;
let logoutCallback = null;

export const setupAxiosInterceptors = (logoutFn, showSessionExpiredFn) => {
  logoutCallback = logoutFn;
  sessionExpiredHandler = showSessionExpiredFn;
  
  // Request interceptor
  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const originalRequest = error.config;
      
      // If error is 401 (Unauthorized) and not already retrying
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        
        console.log('401 Unauthorized response received');
        
        // Check if this is a manual logout
        const isManualLogout = sessionStorage.getItem('manual_logout') === 'true';
        
        if (isManualLogout) {
          console.log('Manual logout in progress - ignoring 401');
          return Promise.reject(error);
        }
        
        // Check if logout is already in progress
        const isLoggingOut = sessionStorage.getItem('is_logging_out') === 'true';
        if (isLoggingOut) {
          console.log('Logout already in progress - ignoring');
          return Promise.reject(error);
        }
        
        // Set logging out flag
        sessionStorage.setItem('is_logging_out', 'true');
        
        console.log('Automatic session expiration detected via 401');
        
        // Clear storage
        localStorage.removeItem('token');
        localStorage.removeItem('user-id');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user-id');
        sessionStorage.removeItem('session_active');
        sessionStorage.removeItem('session_start');
        
        // Show session expired message
        if (sessionExpiredHandler) {
          sessionExpiredHandler();
        }
        
        // Set flag for login page
        sessionStorage.setItem('session_expired', 'true');
        
        // Clear logging out flag after a delay
        setTimeout(() => {
          sessionStorage.removeItem('is_logging_out');
        }, 2000);
        
        // Call logout callback if provided
        if (logoutCallback) {
          logoutCallback();
        }
        
        // Redirect to login
        window.location.href = '/';
        
        return Promise.reject(error);
      }
      
      return Promise.reject(error);
    }
  );
};